import React from "react"
import "./Copy.scss"

export default ({modifier = false, copy}) => (
  <div className={`page__copy${modifier ? ` page__copy--${modifier}` : ''} rte`} dangerouslySetInnerHTML={{__html: copy}} />
)